import { Skeleton } from "../../../../components/ui/common/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "../../../../components/ui/common/table";
import { SupplierRow } from "../types/supplierListView.types";
import { SUPPLIER_TABLE_COLUMNS, supplierTableColumnClass } from "./supplierTable.columns";
import SupplierTableRow from "./SupplierTableRow";

const COLUMN_COUNT = SUPPLIER_TABLE_COLUMNS.length + 1; // + actions column
const ROW_SKELETON_COUNT = 5;

interface SupplierTableProps {
  rows: SupplierRow[];
  isLoading: boolean;
  countryNameById: Map<number, string>;
  onView: (row: SupplierRow) => void;
  onEdit: (row: SupplierRow) => void;
  onDelete: (row: SupplierRow) => void;
}

/** Table shell styled after `ProductTable` — same card container, primary-tinted header, per-column skeleton rows while loading. */
const SupplierTable = ({ rows, isLoading, countryNameById, onView, onEdit, onDelete }: SupplierTableProps) => {
  return (
    <div className="tw-relative tw-min-h-[280px] tw-overflow-x-auto tw-rounded-lg tw-border tw-border-border tw-bg-white">
      <Table className="tw-w-full tw-table-fixed [&_td]:tw-px-4 [&_td]:tw-py-3 [&_th]:tw-px-4 [&_th]:tw-py-3">
        <TableHeader>
          <TableRow className="tw-border-b-0 tw-bg-primary/5 hover:tw-bg-primary/5 [&_th]:tw-bg-primary/5 [&_th]:tw-text-primary [&_th]:tw-font-semibold [&_th]:tw-align-middle">
            {SUPPLIER_TABLE_COLUMNS.map(column => (
              <TableHead key={column.key} className={supplierTableColumnClass[column.key]}>
                {column.label}
              </TableHead>
            ))}
            <TableHead className={`${supplierTableColumnClass.actions} tw-text-right`}>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            [...Array(ROW_SKELETON_COUNT)].map((_, index) => (
              <TableRow key={index} className="tw-bg-white">
                {[...Array(COLUMN_COUNT)].map((__, cellIndex) => (
                  <TableCell key={cellIndex}>
                    <Skeleton className="tw-h-4 tw-w-full" />
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : rows.length === 0 ? (
            <TableRow className="tw-bg-white hover:tw-bg-white">
              <TableCell colSpan={COLUMN_COUNT} className="tw-py-12 tw-text-center tw-text-muted-foreground">
                No suppliers found.
              </TableCell>
            </TableRow>
          ) : (
            rows.map(row => (
              <SupplierTableRow
                key={row._id}
                row={row}
                countryNameById={countryNameById}
                onView={onView}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default SupplierTable;
